"use client"

import AvatarIcon from "@layout/icons/AvatarIcon"
import CheckIconRounded from "@layout/icons/CheckIconRounded"
import HouseIcon from "@layout/icons/HouseIcon"
import PencilIcon from "@layout/icons/PencilIcon"
import { cn } from "@utils/utils"

export const ProgressIndicator = ({ stepIndex }: { stepIndex: number }) => {
  const iconW = 24
  const iconH = 24
  const doneIcon = <CheckIconRounded fill="white" width={iconW} height={iconH} />

  const progressIndicators = [
    {
      step: 0,
      text: "Identifiering",
      icon: stepIndex >= 1 ? doneIcon : <AvatarIcon width={iconW} height={iconH} />
    },
    {
      step: 1,
      text: "Vårdval",
      icon: stepIndex >= 2 ? doneIcon : <HouseIcon width={iconW} height={iconH} />
    },
    {
      step: 2,
      text: "Signering",
      icon: <PencilIcon width={iconW} height={iconH} />
    }
  ]

  return (
    <div className="flex w-full max-w-[29rem] justify-between">
      {progressIndicators.map(step => {
        return (
          <div
            className={cn(
              "relative flex w-48 flex-col items-center justify-center",
              step.step > 0 &&
                "before:absolute before:right-2/4 before:top-[39%] before:h-px before:w-full before:-translate-y-2/4 before:border before:border-dashed before:content-['']",
              stepIndex === 0 && step.step === 1 && "before:border-primary-50",
              step.step === 1 && stepIndex >= step.step && "before:border-solid before:border-primary-50",
              step.step === 2 && stepIndex === 2 && "before:border-solid before:border-primary-50"
            )}
            key={step.step}
          >
            <div
              className={cn(
                "relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-neutral-30 text-white",
                stepIndex >= step.step && "bg-primary-50 text-on-primary-50"
              )}
            >
              {step.icon}
            </div>
            <p className={cn(stepIndex < step.step && "text-neutral-30")}>{step.text}</p>
          </div>
        )
      })}
    </div>
  )
}
